import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from "firebase/firestore";
import { db } from "./config";

export interface CourseChapter {
  id?: string;
  courseSlug: string;
  number: string;
  slug: string;
  title: string;
  centralQuestion: string;
  summary: string;
  difficulty: "Foundation" | "Intermediate" | "Advanced";
  readingTime: number;
  prerequisites: string[];
  outcomes: string[];
  published: boolean;
  order: number;
  lastVerifiedAt?: string;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
}

const chaptersCollection = collection(db, "courseChapters");

export const getAllCourseChapters = async (): Promise<CourseChapter[]> => {
  const snapshot = await getDocs(query(chaptersCollection, orderBy("order", "asc")));
  return snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() } as CourseChapter));
};

export const createCourseChapter = async (
  chapter: Omit<CourseChapter, "id" | "createdAt" | "updatedAt">
): Promise<string> => {
  const docRef = await addDoc(chaptersCollection, {
    ...chapter,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateCourseChapter = async (
  id: string,
  chapter: Partial<Omit<CourseChapter, "id" | "createdAt" | "updatedAt">>
): Promise<void> => {
  await updateDoc(doc(db, "courseChapters", id), {
    ...chapter,
    updatedAt: serverTimestamp(),
  });
};

export const deleteCourseChapter = async (id: string): Promise<void> => {
  await deleteDoc(doc(db, "courseChapters", id));
};

export const reorderCourseChapters = async (orderedIds: string[]): Promise<void> => {
  const batch = writeBatch(db);
  orderedIds.forEach((id, index) => {
    batch.update(doc(db, "courseChapters", id), { order: index, updatedAt: serverTimestamp() });
  });
  await batch.commit();
};
